var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-ld-region-plot" },
    [
      _c("canvas", {
        ref: "canvas",
        staticClass: "vks-ld-region-plot-canvas",
        class: { "is-dot-hover": _vm.dotHover },
        on: {
          mousemove: _vm.onMouseMove,
          mouseout: _vm.onMouseOut,
          click: _vm.onCanvasClick,
        },
      }),
      _c("VariantSifterVariantDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          "variant-id": _vm.dotMenuVariantId,
          "is-starred": _vm.dotMenuIsStarred,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: {
          "set-reference": _vm.onDotMenuSetReference,
          "toggle-star": _vm.onDotMenuToggleStar,
        },
      }),
      _c("div", {
        ref: "tooltip",
        staticClass: "vks-ld-region-plot-tooltip hidden",
      }),
      _vm.loading
        ? _c("p", { staticClass: "vks-ld-region-plot-status" }, [
            _vm._v("Loading LD plot…"),
          ])
        : _vm._e(),
      _vm.error
        ? _c(
            "p",
            {
              staticClass: "vks-ld-region-plot-error",
              attrs: { role: "alert" },
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }